import { DayOfWeek } from '../../enums/DayOfWeek';
import moment from 'moment';

export abstract class AbstractPreferredTimeOff {
  dayOfWeek: DayOfWeek;
  reason: string;
  startTime: string;
  endTime: string;

  protected constructor(
    dayOfWeek: DayOfWeek,
    reason: string,
    startTime: string,
    endTime: string
  ) {
    this.dayOfWeek = dayOfWeek;
    this.reason = reason;
    this.startTime = startTime;
    this.endTime = endTime;
  }

  abstract getFormattedDate(): string;

  getFormattedTime(): string {
    const minStartTime = '00:00:00';
    const maxEndTime = '23:59:59';
    const isAllDay = this.startTime === minStartTime && this.endTime === maxEndTime;
    return isAllDay
      ? 'All day'
      : this.formatTime(this.startTime) + ' - ' + this.formatTime(this.endTime);
  }

  private formatTime(time: string): string {
    return moment(time, 'HH:mm:ss').format('HH:mm');
  }
}
